<form #paddingForm="ngForm">
  <div class="row row-gutters">
    <glxy-form-field suffixText="px" class="col col-xs-6">
      <glxy-label>{{ 'EMAIL_BUILDER.BLOCK_PADDING.TOP_PADDING' | translate }}</glxy-label>
      <input
        matInput
        type="number"
        pattern="[0-9]*"
        inputmode="numeric"
        name="Top Padding"
        placeholder="{{ 'PLACEHOLDER_OPTIONAL' | translate }}"
        [(ngModel)]="padding.top"
        emailHoldShiftToChangeNumberFieldByTen
      />
    </glxy-form-field>
    <glxy-form-field suffixText="px" class="col col-xs-6">
      <glxy-label>{{ 'EMAIL_BUILDER.BLOCK_PADDING.BOTTOM_PADDING' | translate }}</glxy-label>
      <input
        matInput
        type="number"
        pattern="[0-9]*"
        inputmode="numeric"
        name="Bottom Padding"
        placeholder="{{ 'PLACEHOLDER_OPTIONAL' | translate }}"
        [(ngModel)]="padding.bottom"
        emailHoldShiftToChangeNumberFieldByTen
      />
    </glxy-form-field>
  </div>
</form>
